export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_documentation') || '资料文档',
    field: 'documentation',
    headerAlign: 'center',
    align: 'left',
    minWidth: 70,
    slots: { default: 'documentation' },
  },
]
